import { useAuthStore } from '~/stores/auth'
import { useAlertStore } from '~/stores/alert'

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const { isSponsor, user, isAdmin, defaultUserPage } = useAuthStore()
  const alertStore = useAlertStore()

  if (isAdmin)
    return true

  if (user?.yearsInvited?.length) {
    if (user?.yearsInvited[0].accepted)
      return navigateTo(defaultUserPage)
  }
  return true
})
